import { IState } from '@/store/types/search.types';
import { ITemplateGroups, ITemplateModel } from '@/store/models/template.model';
import { TAppError, IBaseAction } from '@/store/types/base.state';

export enum TemplateActionTypes {
  SEARCH_TEMPLATES = 'TEMPLATE.SEARCH_TEMPLATES',
  SEARCH_TEMPLATES_SUCCESS = 'TEMPLATE.SEARCH_TEMPLATES_SUCCESS',
  SEARCH_TEMPLATES_FAIL = 'TEMPLATE.SEARCH_TEMPLATES_FAIL',

  SEARCH_TEMPLATE_MODEL = 'TEMPLATE.SEARCH_TEMPLATE_MODEL',
  SEARCH_TEMPLATE_MODEL_SUCCESS = 'TEMPLATE.SEARCH_TEMPLATE_MODEL_SUCCESS',
  SEARCH_TEMPLATE_MODEL_FAIL = 'TEMPLATE.SEARCH_TEMPLATE_MODEL_FAIL',

  SAVE_TEMPLATE = 'TEMPLATE.SAVE_TEMPLATE',
  SAVE_TEMPLATE_SUCCESS = 'TEMPLATE.SAVE_TEMPLATE_SUCCESS',
  SAVE_TEMPLATE_FAIL = 'TEMPLATE.SAVE_TEMPLATE_FAIL',
}

export interface ISearchTemplateAction extends IBaseAction {
  type: typeof TemplateActionTypes.SEARCH_TEMPLATES;
}

export interface ISearchTemplateSuccessAction extends IBaseAction {
  type: typeof TemplateActionTypes.SEARCH_TEMPLATES_SUCCESS;
  templateKeys: string[];
}

export interface ISearchTemplateFailAction extends IBaseAction {
  type: typeof TemplateActionTypes.SEARCH_TEMPLATES_FAIL;
  error: TAppError;
}

export interface ISearchTemplateModelAction extends IBaseAction {
  type: typeof TemplateActionTypes.SEARCH_TEMPLATE_MODEL;
  group: string;
  name: string;
}

export interface ISearchTemplateModelSuccessAction extends IBaseAction {
  type: typeof TemplateActionTypes.SEARCH_TEMPLATE_MODEL_SUCCESS;
  group: string;
  name: string;
  model: ITemplateModel;
}

export interface ISearchTemplateModelFailAction extends IBaseAction {
  type: typeof TemplateActionTypes.SEARCH_TEMPLATE_MODEL_FAIL;
  group: string;
  name: string;
  error: TAppError;
}

export interface ISaveTemplateModelAction extends IBaseAction {
  type: typeof TemplateActionTypes.SAVE_TEMPLATE;
  group: string;
  name: string;
}

export interface ISaveTemplateModelSuccessAction extends IBaseAction {
  type: typeof TemplateActionTypes.SAVE_TEMPLATE_SUCCESS;
  group: string;
  name: string;
  model: ITemplateModel;
}

export interface ISaveTemplateModelFailAction extends IBaseAction {
  type: typeof TemplateActionTypes.SAVE_TEMPLATE_FAIL;
  group: string;
  name: string;
  error: TAppError;
}

export type TTemplateActions =
  | ISearchTemplateAction
  | ISearchTemplateSuccessAction
  | ISearchTemplateFailAction
  | ISearchTemplateModelAction
  | ISearchTemplateModelSuccessAction
  | ISearchTemplateModelFailAction
  | ISaveTemplateModelAction
  | ISaveTemplateModelSuccessAction
  | ISaveTemplateModelFailAction;

export interface ITemplateState {
  templateGroups: IState<ITemplateGroups>;
}
